import { Component, OnInit } from '@angular/core';
import { Accreditation } from 'src/app/models/accreditation.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-accreditations',
  templateUrl: './accreditations.component.html',
  styleUrls: ['./accreditations.component.scss']
})
export class AccreditationsComponent implements OnInit {
  accreditations: Accreditation[];

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Acreditaciones - CCCISA');
    this.accreditations = [
      new Accreditation('D-120', false, 'Dimensional'),
      new Accreditation('H-25', true, 'Humedad'),
      new Accreditation('M-119', true, 'Masa'),
      new Accreditation('T-72', true, 'Temperatura'),
      new Accreditation('Mediciones-Especiales', false, undefined, 'Mediciones especiales'),
      new Accreditation('Metal-Mecanica', false, undefined, 'Metal mecánica'),
      new Accreditation('P-72', false, 'Presión'),
      new Accreditation('V-70', false, 'Volumen'),
      new Accreditation('Fuentes-fijas', false, undefined, 'Fuentes Fijas'),
      new Accreditation('OP-50', false, 'Óptica'),
      new Accreditation('DEN-31', false, 'Densidad'),
    ];
  }
}
